export default {
  // 获取服务状态
  getStatus() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/status')
      .then((res) => {
        return res;
      });
  },

  // 获取七牛上传Token
  getUploadToken(key) {
    return this.http('ExerciseCheck', 'get', `/api/v1/upload_token?key=${key}`)
      .then((res) => {
        return res;
      });
  },

  // 上传拍照记录
  postPhotoRecords(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/records', params)
      .then((res) => {
        return res;
      });
  },

  // 评测提交
  postEvaluation(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/evaluations', params)
      .then((res) => {
        return res;
      });
  },

  // 服务激活
  postActivate(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/activate', params)
      .then((res) => {
        return res;
      });
  },

  // 获取今日计划
  getPlan(params) {
    return this.http('ExerciseCheck', 'get', `/api/v1/rectify/plan?seq=${params}`)
      .then((res) => {
        return res;
      });
  },

  // 美腿打卡
  postCheckIn() {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/checkin')
      .then((res) => {
        return res;
      });
  },

  // 获取打卡日历
  getCalendar() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/calendar')
      .then((res) => {
        return res;
      });
  },

  // 获取照片记录
  getPhotoRecords() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/records')
      .then((res) => {
        return res;
      });
  },

  // 服务结束
  getRectifyOver() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/history')
      .then((res) => {
        return res;
      });
  }
};
